// Central API base for the ICECYS manager-frontend.
//
// Why this exists: every module call used to hardcode `http://110.77.132.5:8009`, which
// breaks under HTTPS (Mixed Content — an HTTPS page cannot call an http:// resource).
// All calls now go through this single base.
//
// Set REACT_APP_API_BASE at build time:
//   - webtest (HTTPS):  REACT_APP_API_BASE=https://test-api-tokyo.icecys.com  (reverse-proxy → gateway)
//   - local dev:        REACT_APP_API_BASE=http://110.77.132.5:8009           (or your own gateway)
// Empty default = same-origin relative calls (only correct if a same-origin proxy fronts the gateway).
export const API_BASE_URL = window.__API_BASE__ || process.env.REACT_APP_API_BASE || "";

// WebSocket base derived from the API base (http→ws, https→wss). hwcontrol uses it for
// live serial. Under HTTPS this MUST be wss:// or the browser blocks it (Mixed Content),
// and the reverse proxy must allow the WebSocket upgrade on /hwcontrol/api/ws/*.
export const WS_BASE_URL = API_BASE_URL.replace(/^http/, "ws");
